import script from "./CreateProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateProfile.vue?vue&type=script&lang=ts&setup=true"

import "./CreateProfile.vue?vue&type=style&index=0&id=0a94c57e&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a94c57e"]])

export default __exports__